<app-payment-panel-stripe-generic type="STRIPE_BANCONTACT"></app-payment-panel-stripe-generic>
